package com.eladfinish.bible.contest.ui.components.bottomSheet

import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.SheetState
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.unit.takeOrElse
import com.eladfinish.bible.contest.screens.randomVerse.ui.model.toAnnotatedText
import com.eladfinish.bible.contest.text.SpannableStringKMP
import com.eladfinish.bible.contest.ui.components.mouseVerticalScrollbar

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun RichScrollableBottomSheetAnimatedClose(
    sheetState: SheetState,
    onHide: () -> Unit,
    spannable: SpannableStringKMP,
    title: String? = null,
    modifier: Modifier = Modifier,
) {
    // Now uses the built-in linkInteractionListener logic from toAnnotatedText
    val baseFontSize = MaterialTheme.typography.bodyLarge.fontSize.takeOrElse { 16.sp }
    val annotatedText = spannable.toAnnotatedText(baseFontSize = baseFontSize)

    ModalBottomSheetWithAnimatedClose(
        sheetState = sheetState,
        onHide = onHide,
        title = title,
        modifier = modifier,
        contentPadding = PaddingValues(0.dp),
    ) {
        val scrollState = rememberScrollState()

        Column(
            modifier = Modifier
                .fillMaxWidth()
                .heightIn(min = 120.dp, max = 520.dp)
                .mouseVerticalScrollbar(scrollState)
                .verticalScroll(scrollState)
                .padding(16.dp),
        ) {
            Text(
                text = annotatedText.annotatedString,
                style = MaterialTheme.typography.bodyLarge,
                modifier = Modifier.fillMaxWidth(),
            )

            Spacer(
                modifier = Modifier.height(24.dp),
            )
        }
    }
}
